export function filterNumber(event) {
  const expect = event.target.value.toString() + event.key.toString();

  return !/^[-+]?[0-9]*\.?[0-9]*$/.test(expect) ? event.preventDefault() : true;
}
